import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NotificationConfigData, NotificationRuleData } from '@navfleet/client/shared/models/notification';
import { environment } from '@navfleet/shared/core/environment';
import { Observable } from 'rxjs';

export const SETTINGS_NOTIFICATION_RULE_API = `${environment.NAVFLEET_BACKEND}/api/v1/notifications/rules`;

@Injectable({
    providedIn: 'root',
})
export class SettingsNotificationRuleApi {
    private http = inject(HttpClient);

    public getNotificationRuleConfig(): Observable<NotificationConfigData> {
        return this.http.get<NotificationConfigData>(`${SETTINGS_NOTIFICATION_RULE_API}/configuration`, {
            responseType: 'json',
        });
    }

    public getNotificationRules(): Observable<NotificationRuleData[]> {
        return this.http.get<NotificationRuleData[]>(SETTINGS_NOTIFICATION_RULE_API, { responseType: 'json' });
    }

    public fetchNotificationRule(id: number): Observable<NotificationRuleData> {
        return this.http.get<NotificationRuleData>(`${SETTINGS_NOTIFICATION_RULE_API}/${id}`, { responseType: 'json' });
    }

    public createNotificationRule(rule: Omit<NotificationRuleData, 'id'>): Observable<NotificationRuleData> {
        return this.http.post<NotificationRuleData>(SETTINGS_NOTIFICATION_RULE_API, rule, { responseType: 'json' });
    }

    public updateNotificationRule(rule: NotificationRuleData): Observable<NotificationRuleData> {
        return this.http.put<NotificationRuleData>(`${SETTINGS_NOTIFICATION_RULE_API}/${rule.id}`, rule, {
            responseType: 'json',
        });
    }

    public deleteNotificationRule(id: number): Observable<NotificationRuleData> {
        return this.http.delete<NotificationRuleData>(`${SETTINGS_NOTIFICATION_RULE_API}/${id}`, {
            responseType: 'json',
        });
    }

    public activateNotificationRule(id: number): Observable<NotificationRuleData> {
        return this.http.post<NotificationRuleData>(`${SETTINGS_NOTIFICATION_RULE_API}/${id}/reactivate`, {
            responseType: 'json',
        });
    }

    public deactivateNotificationRule(id: number): Observable<NotificationRuleData> {
        return this.http.post<NotificationRuleData>(`${SETTINGS_NOTIFICATION_RULE_API}/${id}/deactivate`, {
            responseType: 'json',
        });
    }
}
